


















































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  IPageConfig,
  IPageParams,
  IPageSrc,
} from "@/@types/filoxenia-config/nav-bar";
import { ILocale } from "@/@types/locale";
import { pics } from "@/config/host.config";

import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import LanguagesButtons from "@/components/buttons/languages-buttons.vue";
import BSwitch from "@/components/app/switchs/b-switch.vue";
import StandartSelect from "@/components/app/selects/standart-select.vue";
import UploadingImageToServer from "@/components/app/images/uploading-image-to-server.vue";
import { deleteImages } from "@/api/delite/delite-element";

@Component({
  components: {
    onsubmit: SubmitResetButtonGroop,
    upload: UploadingImageToServer,
    LanguagesButtons,
    BSwitch,
    "s-select": StandartSelect,
  },
})
class AddRouteForm extends Vue {
  @Prop({ type: Object, default: null }) item!: IPageConfig | null;
  @Prop({ type: Array, default: () => [] }) pages!: Array<IPageConfig>;

  languages = this.$store.getters.getLanguages;
  locale = this.languages[0];
  iconfolder = "main/configuration/icons";
  navicons: Array<string> = [];

  name = "";
  names: ILocale = {};

  footer = "";
  footers: Array<string> = [];

  show = true;
  active = true;
  lock = false;

  tvRoute = "";
  mobileRoute = "";
  grid = 1;
  variantClass = "";

  navigationGroup = "";
  pageGroup = "";
  children: Array<string> = [];

  background = "";
  poster = "";
  image = "";
  iconName = "";
  iconLib = "";
  svg = "";

  get gridOptions(): Array<{ value: string | number; text: string }> {
    return [1, 2, 3, 4].map((n) => ({ value: n, text: String(n) }));
  }

  get libOptions(): Array<{ value: string | number; text: string }> {
    return [
      { value: "", text: "—" },
      { value: "material", text: "material" },
      { value: "filoxenia", text: "filoxenia" },
    ];
  }

  get pageOptions(): Array<{ value: string | number; text: string }> {
    return this.pages
      .filter((page) => !this.item || page._id !== this.item._id)
      .map((page) => ({
        value: page._id,
        text: page.name.ru || page.name.en || page._id,
      }));
  }

  get pageGroupOptions(): Array<{ value: string | number; text: string }> {
    return [{ value: "", text: "—" }, ...this.pageOptions];
  }

  get srcIcon(): IPageSrc["icon"] {
    return this.iconLib
      ? { icon: this.iconName, lib: this.iconLib }
      : this.iconName;
  }

  get pageParams(): IPageParams {
    return {
      tv: {
        footer: this.footers,
        route: this.tvRoute,
        variant: { grid: this.grid, class: this.variantClass },
      },
      mobile: { route: this.mobileRoute },
    };
  }

  get nav(): Partial<IPageConfig> {
    const data: Partial<IPageConfig> = {
      name: this.names,
      show: this.show,
      active: this.active,
      lock: this.lock,
      route: this.tvRoute,
      nav: this.navigationGroup,
      grid: this.grid,
      children: this.children,
      src: {
        background: this.background,
        poster: this.poster,
        image: this.image,
        icon: this.srcIcon,
        svg: this.svg,
      },
      params: this.pageParams,
      navigation: {
        children: this.children,
        pageGroup: this.pageGroup,
        navigationGroup: this.navigationGroup,
      },
    };
    if (!this.item) {
      data.footer = this.footers;
      data.informers = [];
    }
    return data;
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (!this.$getRootPermition()) {
      this.$bvModal.hide("root-setting-routes-change");
      return;
    }

    const id = this.item ? this.item._id : "";
    this.$emit("updateRoute", this.nav, id);
    this.$bvModal.hide("root-setting-routes-change");
  }

  svgName(name: string): void {
    const arr = name.split(".");
    this.svg = arr[0];
  }

  @Watch("name")
  changeLocale(): void {
    this.names[this.locale] = this.name;
  }

  @Watch("footer")
  changeFooters(): void {
    this.footers = this.footer
      .split(",")
      .map((el) => el.trim())
      .filter((el) => el.length > 0);
  }

  @Watch("locale")
  updateName(): void {
    if (this.names)
      this.name = this.names[this.locale] ? this.names[this.locale] : "";
    else this.name = "";
  }

  @Watch("item")
  cteatedLocales(): void {
    if (!this.item) return;
    this.names = this.item.name ? this.item.name : {};
    this.updateName();
    this.show = this.item.show;
    this.active = this.item.active;
    this.lock = this.item.lock;
    this.footers = this.item.params?.tv?.footer
      ? this.item.params.tv.footer
      : [];
    this.footer = this.footers.length ? this.footers.join(",") : "";
    this.tvRoute = this.item.params?.tv?.route
      ? this.item.params.tv.route
      : this.item.route
      ? this.item.route
      : "";
    this.grid = this.item.params?.tv?.variant?.grid
      ? this.item.params.tv.variant?.grid
      : this.item.grid
      ? this.item.grid
      : 1;
    this.variantClass = this.item.params?.tv?.variant?.class
      ? this.item.params.tv.variant?.class
      : "";
    this.mobileRoute = this.item.params?.mobile?.route
      ? this.item.params.mobile.route
      : "";
    this.navigationGroup = this.item.navigation?.navigationGroup
      ? this.item.navigation.navigationGroup
      : this.item.nav
      ? this.item.nav
      : "";
    this.pageGroup = this.item.navigation?.pageGroup
      ? this.item.navigation.pageGroup
      : "";
    this.children = this.item.navigation?.children
      ? this.item.navigation.children
      : this.item.children
      ? this.item.children
      : [];
    this.background = this.item.src ? this.item.src.background : "";
    this.poster = this.item.src ? this.item.src.poster : "";
    this.image = this.item.src?.image ? this.item.src.image : "";
    const srcIcon = this.item.src ? this.item.src.icon : "";
    if (srcIcon && typeof srcIcon === "object") {
      this.iconName = srcIcon.icon;
      this.iconLib = srcIcon.lib;
    } else {
      this.iconName = typeof srcIcon === "string" ? srcIcon : "";
      this.iconLib = "";
    }
    this.svg = this.item.src ? this.item.src.svg : "";
  }

  onReset(): void {
    this.cteatedLocales();
  }

  async getNavIcons(): Promise<void> {
    const params = { path: this.iconfolder };
    try {
      const resicon = await this.$axios.get(pics.download, { params });
      if (resicon.status === 200) {
        this.navicons =
          resicon.data == "Папка не найдена" || resicon.data == "Папка пуста"
            ? []
            : resicon.data;
      }
    } catch (error) {
      console.error(error);
    }
  }

  async deletedIcon(id: string): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("confirm.delete.icon")),
        }
      );

      if (result === true) {
        deleteImages(id, this.iconfolder);
      }
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  mounted(): void {
    this.getNavIcons();
    this.cteatedLocales();
  }
}
export default AddRouteForm;
